<template>
    <v-dialog v-model="show" fullscreen>
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs"></slot>
        </template>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('conciliacaoViagens.dialogs.editTrip.title') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-form ref="form" v-model="isFormValid">
                        <v-row>
                            <v-col cols="12" sm="4" md="3">
                                <v-datetime-picker :label="$t('conciliacaoViagens.dialogs.editTrip.initialDate')"
                                    v-model="dtiPosicoes" :time-picker-props="timeProps"
                                    :date-picker-props="dtiProps" :text-field-props="textFieldProps"
                                    time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                                    :clear-text="$t('datetime.close')" ref="dtiPosicoesPicker">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="4" md="3">
                                <v-datetime-picker :label="$t('conciliacaoViagens.dialogs.editTrip.finalDate')"
                                    v-model="dtfPosicoes" :time-picker-props="timeProps"
                                    :date-picker-props="dtfProps" :text-field-props="textFieldProps"
                                    time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                                    :clear-text="$t('datetime.close')" ref="dtfPosicoesPicker">
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-combobox v-model="veiculoSelected" :items="veiculos" item-text="numero_ordem"
                                    return-object clearable
                                    :label="$t('conciliacaoViagens.dialogs.editTrip.vehicle')"
                                    :disabled="veiculoDisabled || bloqueadoMesFechado"
                                    :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectVehicle')]"></v-combobox>
                            </v-col>
                            <v-col cols="12" sm="6" md="1" align="end">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs"
                                            v-on="on" @click="populaMapa" style="margin-bottom: 5px;" :disabled="veiculoNaoCadastrado">
                                            <v-icon>mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('conciliacaoViagens.dialogs.editTrip.search') }}</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <LazySelect
                                    ref="linhaSelect"
                                    get-url="getLinhaslazy"
                                    :text="rotuloLinha"
                                    value="id_linha"
                                    :disabled="linhaDisabled || bloqueadoMesFechado"
                                    :label="$t('conciliacaoViagens.dialogs.editTrip.lineName')"
                                    :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectLine')]"
                                    @input="onLinhaAssociadaSelect"
                                />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field 
                                    :value="selectedLinha ? selectedLinha.cod_linha : ''"
                                    :label="$t('conciliacaoViagens.dialogs.editTrip.line')"
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-select v-model="editedViagem.id_sentido" :items="sentidos"
                                    item-text="descricao_sentido" item-value="id_sentido"
                                    :disabled="sentidoDisabled || bloqueadoMesFechado"
                                    :label="$t('conciliacaoViagens.dialogs.editTrip.direction')"
                                    :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectDirection')]"></v-select>
                            </v-col>
                        </v-row>
                    </v-form>

                    <div id="mapcontainer">
                        <l-map ref="map" :zoom="zoom" :center="currentCenter" :options="mapOptions" @ready="onMapReady"
                            v-resize="onMapResize" :key="mapKey">
                            <l-tile-layer :url="url" :attribution="attribution" />

                            <l-control :position="'bottomleft'" v-if="posicaoSelected">
                                <v-card style="border-radius: 10px;">
                                    <v-card-text>
                                        <pre>{{ $t('conciliacaoViagens.map.dateTime') }}: {{ posicaoSelected?.dt_posicao_extenso }}</pre>
                                        <pre>{{ $t('conciliacaoViagens.map.speed') }}: {{ posicaoSelected?.velocidade }} {{
                                            $t('conciliacaoViagens.map.kmh') }}</pre>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green" dark @click="atualizarViagem(1)" small
                                            :disabled="horarioSaidaDisabled || bloqueadoMesFechado">{{
                                                $t('conciliacaoViagens.dialogs.editTrip.startTrip') }}</v-btn>
                                        <v-btn color="red" dark @click="atualizarViagem(2)" small
                                            :disabled="horarioChegadaDisabled || bloqueadoMesFechado">{{
                                                $t('conciliacaoViagens.dialogs.editTrip.finishTrip') }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </l-control>

                            <l-control :position="'topright'">
                                <v-card style="border-radius: 10px;">
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-checkbox v-model="showCercas"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.fences')"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-checkbox v-model="showRota"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.route')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </l-control>

                            <Vue2LeafletRotatedMarker v-for="(reg, k) in posicoes" :key="`${reg.id_veiculo}-${k}`"
                                :lat-lng="latLng(reg.lat, reg.lng)" :icon="getIconPosicao(reg)"
                                @click="showDetalhesPosicoes(k)" :rotationAngle="parseInt(reg.rumo)"
                                :rotationOrigin="'15px 15px'">
                            </Vue2LeafletRotatedMarker>

                            <l-geo-json v-for="(rota, i) in rotas" :key="`ROTA-${i}`" :geojson="rota.geojson"
                                :visible="showRota" />
                            <l-geo-json v-for="(cerca, i) in cercasGeojson" :key="`CERCA-GEOJSON-${i}`"
                                :geojson="cerca.geojson" :options-style="cerca.style" :options="cerca.options" :visible="showCercas">
                            </l-geo-json>
                            <l-circle v-for="(cerca, i) in cercasCirculares" :key="`CERCA-CIRCULAR-${i}`"
                                :radius="cerca.raio_mts" :lat-lng="latLng(cerca.lat_centro, cerca.lng_centro)"
                                :options="cerca.style" :visible="showCercas">
                                <l-tooltip :content="cerca.nome_cerca"></l-tooltip>
                            </l-circle>
                        </l-map>
                    </div>

                    <v-card style="margin-top: 10px; border-radius: 10px;">
                        <v-card-title>
                            {{ $t('conciliacaoViagens.dialogs.editTrip.trip') }}
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-alert
                                    v-if="Number(editedViagem.is_viagem_invalida) === 1"
                                    type="warning"
                                    prominent
                                    border="left"
                                    class="mb-4"
                                >
                                    <div class="font-weight-medium">{{ $t('fechamentoDia.invalidTrip.alertTitle') }}</div>
                                    <div v-if="editedViagem.motivo_viagem_invalida" class="mt-1">
                                        {{ $t('fechamentoDia.invalidTrip.reason') }}: {{ editedViagem.motivo_viagem_invalida }}
                                    </div>
                                    <div v-if="editedViagem.data_hora_invalidacao_extenso" class="mt-1">
                                        {{ $t('fechamentoDia.invalidTrip.invalidatedAt') }}: {{ editedViagem.data_hora_invalidacao_extenso }}
                                    </div>
                                </v-alert>
                                <v-form ref="formDetalhesViagem" v-model="formValidadoDetalhesViagem">
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="editedViagem.id_guia_realizada" :items="guiasFiltered"
                                                @change="guiaChanged"
                                                item-text="guia_original" item-value="id_guia"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.guide')"
                                                :disabled="guiaDisabled || bloqueadoMesFechado"></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="editedViagem.escalonamento_veiculo"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.scaling')"
                                                :disabled="escalonamentoDisabled || bloqueadoMesFechado"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-datetime-picker
                                                v-model="horarioSaidaRealizada"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.realizedDeparture')"
                                                :time-picker-props="timeProps"
                                                :date-picker-props="dtiProps"
                                                :text-field-props="textFieldProps"
                                                time-format="HH:mm:ss"
                                                date-format="dd/MM/yyyy"
                                                :clear-text="$t('datetime.close')"
                                                ref="horarioSaidaRealizadaPicker"
                                                :disabled="horarioSaidaDisabled || bloqueadoMesFechado"
                                            >
                                                <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                </template>
                                                <template slot="timeIcon">
                                                    <v-icon>mdi-clock</v-icon>
                                                </template>
                                            </v-datetime-picker>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-datetime-picker
                                                v-model="horarioChegadaRealizada"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.realizedArrival')"
                                                :time-picker-props="timeProps"
                                                :date-picker-props="dtfProps"
                                                :text-field-props="textFieldProps"
                                                time-format="HH:mm:ss"
                                                date-format="dd/MM/yyyy"
                                                :clear-text="$t('datetime.close')"
                                                ref="horarioChegadaRealizadaPicker"
                                                :disabled="horarioChegadaDisabled || bloqueadoMesFechado"
                                            >
                                                <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                </template>
                                                <template slot="timeIcon">
                                                    <v-icon>mdi-clock</v-icon>
                                                </template>
                                            </v-datetime-picker>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-select v-model="editedViagem.id_classificacao" :items="classificacoes"
                                                item-text="descricao_classificacao" item-value="id_classificacao"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.classification')"
                                                :disabled="classificacaoDisabled || bloqueadoMesFechado"></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-autocomplete v-model="editedViagem.id_cerca_inicio" :items="cercasSelect"
                                                item-text="nome_cerca" item-value="id_cerca"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.startFence')"
                                                :disabled="cercaInicioDisabled || bloqueadoMesFechado">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-autocomplete v-model="editedViagem.id_cerca_fim" :items="cercasSelect"
                                                item-text="nome_cerca" item-value="id_cerca"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.arrivalFence')"
                                                :disabled="cercaFimDisabled || bloqueadoMesFechado">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4" md="4">
                                            <v-text-field v-model="ocupacao"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.occupation')"
                                                :disabled="ocupacaoDisabled || bloqueadoMesFechado"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4">
                                            <v-text-field v-model="editedViagem.lotacao"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.capacity')"
                                                :disabled="lotacaoDisabled || bloqueadoMesFechado"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4">
                                            <v-text-field v-model="kmAferido"
                                                type="number"
                                                step="0.01"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.kmRealized')"
                                                :disabled="kmRealizadoDisabled || bloqueadoMesFechado"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <HodometrosViagemInfo ref="hodometrosViagem"
                                                :id-viagem-grid="editedViagem.id_viagem_grid" editavel
                                                :disabled="preferenciaHodometroDisabled || bloqueadoMesFechado"></HodometrosViagemInfo>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :value="editedViagem.tipo_abertura"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.opening')" readonly
                                                :disabled="true"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :value="editedViagem.dt_abertura_manual_extenso"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.openedAt')" readonly
                                                :disabled="true"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-text-field :value="editedViagem.nome_usuario_abertura_manual"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.user')" readonly
                                                :disabled="true"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :value="editedViagem.tipo_fechamento"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.closing')" readonly
                                                :disabled="true"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :value="editedViagem.dt_fechamento_manual_extenso"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.closedAt')" readonly
                                                :disabled="true"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-text-field :value="editedViagem.nome_usuario_fechamento_manual"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.user')" readonly
                                                :disabled="true"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-select v-model="idMotivoAbertura" :items="motivos"
                                                item-text="descricao_motivo" item-value="id_motivo"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.openingReason')"
                                                :disabled="motivoAberturaDisabled || bloqueadoMesFechado"></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <v-text-field v-model="observacoesAbertura"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                                                :disabled="observacoesAberturaDisabled || bloqueadoMesFechado"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-select v-model="idMotivoFechamento" :items="motivos"
                                                item-text="descricao_motivo" item-value="id_motivo"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.closingReason')"
                                                :disabled="motivoFechamentoDisabled || bloqueadoMesFechado"></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <v-text-field v-model="observacoesFechamento"
                                                :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                                                :disabled="observacoesFechamentoDisabled || bloqueadoMesFechado"></v-text-field>
                                        </v-col>
                                    </v-row>
                                <v-row v-if="editedViagem.dt_revalidacao_extenso">
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field
                                            :value="editedViagem.dt_revalidacao_extenso"
                                            :label="$t('fechamentoDia.revalidate.revalidatedAt')"
                                            readonly
                                            :disabled="true"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field
                                            :value="editedViagem.nome_usuario_revalidacao"
                                            :label="$t('fechamentoDia.revalidate.revalidatedBy')"
                                            readonly
                                            :disabled="true"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                        v-model="editedViagem.id_motivo_conciliacao_manual"
                                        :items="motivos"
                                        item-text="descricao_motivo"
                                        item-value="id_motivo"
                                        :label="$t('conciliacaoViagens.dialogs.editTrip.manualConciliationReason')"
                                        readonly
                                        :disabled="motivoConciliacaoManualDisabled || bloqueadoMesFechado"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-text-field
                                        v-model="editedViagem.observacoes_conciliacao_manual"
                                        :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                                        readonly
                                        :disabled="observacoesConciliacaoManualDisabled || bloqueadoMesFechado"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                    </v-card>
                    <v-card style="margin-top: 10px; border-radius: 10px;">
                        <v-card-title>
                            <span class="headline" style="color: #4a4a4a">
                                Diário de Bordo
                            </span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-form ref="diarioForm" v-model="diarioFormValidado">
                                    <v-row>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-autocomplete
                                                v-model="itemDiario.id_tipo_entrada_diario"
                                                :items="tiposEntradaDiario"
                                                item-text="descricao_tipo_entrada"
                                                item-value="id_tipo_entrada_diario"
                                                clearable
                                                label="Tipo"
                                                :disabled="tipoEntradaDisabled || bloqueadoMesFechado"
                                                :rules="[(v) => !!v || 'Tipo é obrigatório']"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-autocomplete
                                                v-model="itemDiario.id_motivo"
                                                :items="motivos"
                                                item-text="descricao_motivo"
                                                item-value="id_motivo"
                                                clearable
                                                label="Motivo"
                                                :rules="[(v) => !!v || 'Motivo é obrigatório']"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-datetime-picker
                                                label="Data Entrada"
                                                v-model="dtEntradaDiario"
                                                :time-picker-props="timeProps"
                                                :text-field-props="textFieldProps"
                                                time-format="HH:mm:ss"
                                                date-format="dd/MM/yyyy"
                                                clear-text="Fechar"
                                                :rules="[(v) => !!v || 'Data é obrigatória']"
                                            >
                                                <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                </template>
                                                <template slot="timeIcon">
                                                    <v-icon>mdi-clock</v-icon>
                                                </template>
                                            </v-datetime-picker>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="10" md="10">
                                            <v-textarea
                                                v-model="itemDiario.observacoes"
                                                label="Observações"
                                                auto-grow
                                                clearable
                                                counter
                                                rows="1"
                                                :rules="[(v) => (v === null || v.length <= 1000) || 'Máximo de 1000 caracteres']"
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-btn
                                                color="primary"
                                                dark
                                                small
                                                class="mb-2"
                                                fab
                                                @click="saveEntrada"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-row>
                                    <v-container>
                                        <v-data-table
                                            :headers="headersDiario"
                                            :items="entradasDiario"
                                            sort-by="dt_entrada"
                                            dense
                                            class="elevation-7"
                                            locale="pt"
                                            :loading="loadingDiario"
                                            show-expand
                                            :single-expand="true"
                                            item-key="id_entrada_diario"
                                            loading-text="Carregando..."
                                            style="border-radius: 10px"
                                        >
                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="margin: 0;padding: 5px;">
                                                    <v-simple-table dense>
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th>Registrado Por</th>
                                                                    <th>Registrado Em</th>
                                                                    <th>Editado Por</th>
                                                                    <th>Editado Em</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{{ item.usuario_inclusao }}</td>
                                                                    <td>{{ item.dt_inclusao }}</td>
                                                                    <td>{{ item.usuario_edicao }}</td>
                                                                    <td>{{ item.dt_edicao }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-container>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-alert v-if="bloqueadoMesFechado" type="warning" dense text class="ma-0 flex-grow-1"
                    icon="mdi-lock-outline" style="border-radius: 10px">
                    {{ avisoMesFechado || $t('closingMonth.editBlockedShort') }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="Number(editedViagem.is_viagem_invalida) === 1"
                    color="deep-orange darken-2"
                    dark
                    class="mr-2"
                    :loading="revalidating"
                    :disabled="bloqueadoMesFechado"
                    @click="revalidarViagem"
                >
                    {{ $t('fechamentoDia.revalidate.button') }}
                </v-btn>
                <v-btn color="primary" :loading="salvando" :disabled="bloqueadoMesFechado" @click="updateViagemGrid">{{ $t('button.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EventBus from '@/utils/eventBus';
import DateUtils from '@/utils/dateutils';
import apiController from '@/utils/apiController';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { LMap, LTileLayer, LControl, LCircle, LTooltip, LGeoJson } from 'vue2-leaflet';
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import LazySelect from '@/components/Selects/LazySelect.vue';
import HodometrosViagemInfo from '@/components/Viagem/HodometrosViagemInfo.vue';
import { medeHodometros } from '@/utils/hodometroPreferencia';

export default {
    components: {
        LazySelect,
        HodometrosViagemInfo,
        LMap,
        LTileLayer,
        LControl,
        Vue2LeafletRotatedMarker,
        LCircle,
        LTooltip,
        LGeoJson,
    },
    name: 'UpdateViagemDialog',
    props: {
        viagem: {
            type: Object,
            required: true
        },
        dialog: {
            type: Boolean,
            required: true
        },
        mapKey: {
            type: Number,
            default: 0
        },
        dtReferencia: {
            type: String,
            default: null
        },
        /**
         * Viagem congelada por fechamento de mês: a API recusa a alteração (409), então o
         * diálogo abre em modo leitura, com aviso, em vez de deixar o usuário preencher um
         * formulário que não salva.
         */
        bloqueadoMesFechado: {
            type: Boolean,
            default: false
        },
        avisoMesFechado: {
            type: String,
            default: ''
        },
        veiculoDisabled: {
            type: Boolean,
            default: false
        },
        preferenciaHodometroDisabled: {
            type: Boolean,
            default: false
        },
        linhaDisabled: {
            type: Boolean,
            default: false
        },
        sentidoDisabled: {
            type: Boolean,
            default: false
        },
        guiaDisabled: {
            type: Boolean,
            default: false
        },
        cercaInicioDisabled: {
            type: Boolean,
            default: false
        },
        cercaFimDisabled: {
            type: Boolean,
            default: false
        },
        escalonamentoDisabled: {
            type: Boolean,
            default: false
        },
        horarioSaidaDisabled: {
            type: Boolean,
            default: false
        },
        horarioChegadaDisabled: {
            type: Boolean,
            default: false
        },
        classificacaoDisabled: {
            type: Boolean,
            default: false
        },
        kmRealizadoDisabled: {
            type: Boolean,
            default: false
        },
        ocupacaoDisabled: {
            type: Boolean,
            default: false
        },
        lotacaoDisabled: {
            type: Boolean,
            default: false
        },
        motivoAberturaDisabled: {
            type: Boolean,
            default: false
        },
        observacoesAberturaDisabled: {
            type: Boolean,
            default: false
        },
        motivoFechamentoDisabled: {
            type: Boolean,
            default: false
        },
        observacoesFechamentoDisabled: {
            type: Boolean,
            default: false
        },
        motivoConciliacaoManualDisabled: {
            type: Boolean,
            default: false
        },
        observacoesConciliacaoManualDisabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                this.populaCamposViagem();
            } else {
                this.limpaCamposViagem();
            }
        },
    },
    data: () => ({
        isFormValid: false,
        formValidadoDetalhesViagem: false,
        user: null,
        token: null,
        motivos: [],
        cercas: [],
        rotas: [],
        cercasGeojson: [],
        cercasCirculares: [],
        posicoes: [],
        /** Registro completo da linha associada (traz distancia_ida/volta, ausentes no lazy). */
        linhaAssociadaDetalhe: null,
        sentidos: [],
        veiculos: [],
        guias: [],
        classificacoes: [],
        currentCenter: [0, 0], // Valor padrão temporário até carregar a configuração
        mapOptions: {
            zoomSnap: 0.5,
        },
        zoom: 12,
        map: null,
        showCercas: true,
        showRota: true,
        showAlertVeiculosDistintos: false,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        timeProps: {
            useSeconds: true,
        },
        dti: null,
        dtf: null,
        dtiPosicoes: null,
        dtfPosicoes: null,
        posicaoSelected: null,
        horarioSaidaRealizada: null,
        horarioChegadaRealizada: null,
        idMotivoAbertura: null,
        observacoesAbertura: null,
        idMotivoFechamento: null,
        observacoesFechamento: null,
        veiculoSelected: null,
        idLinhaAssociada: null,
        idSentidoSelected: null,
        idCercaInicio: null,
        idCercaFim: null,
        config: null,
        center: null,
        kmAferido: null,
        ocupacao: null,
        cercasSelect: [],
        headersDiario: [
            { text: "Id Entrada", value: "id_entrada_diario", align: " d-none"},
            { text: "Data", value: "dt_entrada" },
            { text: "Tipo", value: "descricao_tipo_entrada" },
            { text: "Motivo", value: "descricao_motivo" },
            { text: "Observações", value: "observacoes" },
        ],
        itemDiario: {
            id_tipo_entrada_diario: null,
            id_motivo: null,
            id_linha: null,
            id_veiculo: null,
            id_viagem: null,
            dt_entrada: null,
            id_usuario_inclusao: null,
            dt_inclusao: null,
            id_usuario_edicao: null,
            dt_edicao: null,
            observacoes: null
        },
        defaultItemDiario: {
            id_tipo_entrada_diario: null,
            id_motivo: null,
            id_linha: null,
            id_veiculo: null,
            id_viagem: null,
            dt_entrada: null,
            id_usuario_inclusao: null,
            dt_inclusao: null,
            id_usuario_edicao: null,
            dt_edicao: null,
            observacoes: null
        },
        entradasDiario: [],
        tiposEntradaDiario: [],
        dtEntradaDiario: null,
        loadingDiario: false,
        diarioForm: null,
        tipoEntradaDisabled: false,
        diarioFormValidado: false,
        revalidating: false,
        salvando: false,
        editedViagem: {
            id_viagem_grid: null,
            id_viagem_prevista: null,
            horario_saida_realizada: null,
            horario_chegada_realizada: null,
            id_viagem_realizada: null,
            id_guia_realizada: null,
            numero_guia_realizada: null,
            id_veiculo_realizado: null,
            numero_ordem_veiculo_realizado: null,
            escalonamento_veiculo: null,
            id_motorista_realizado: null,
            matricula_motorista_realizado: null,
            nome_motorista_realizado: null,
            id_cobrador_realizado: null,
            matricula_cobrador_realizado: null,
            nome_cobrador_realizado: null,
            id_sentido: null,
            id_cerca_inicio: null,
            nome_cerca_inicio: null,
            cod_cerca_inicio: null,
            id_cerca_fim: null,
            nome_cerca_fim: null,
            cod_cerca_fim: null,
            tempo_de_placa: null,
            passageiros_totais: null,
            passageiros_pagantes: null,
            passageiros_gratuidades: null,
            passageiros_vt: null,
            hodometro_inicial: null,
            dt_hodometro_inicial: null,
            hodometro_final: null,
            dt_hodometro_final: null,
            consumo_inicial: null,
            dt_consumo_inicial: null,
            consumo_final: null,
            dt_consumo_final: null,
            id_origem: null,
            temp_media: null,
            condicao_climatica: null,
            id_motivo_abertura_manual: null,
            observacoes_abertura_manual: null,
            id_motivo_fechamento_manual: null,
            observacoes_fechamento_manual: null,
            dt_abertura_manual: null,
            id_usuario_abertura_manual: null,
            dt_fechamento_manual: null,
            id_usuario_fechamento_manual: null,
            dt_associacao_manual: null,
            id_usuario_associacao_manual: null,
            id_linha_associada: null,
            cod_linha_associada: null,
            id_classificacao: null,
            nome_usuario_abertura_manual: null,
            nome_usuario_fechamento_manual: null,
            tipo_abertura: null,
            tipo_fechamento: null,
            dt_abertura_manual_extenso: null,
            dt_fechamento_manual_extenso: null,
            ocupacao: null,
            lotacao: null,
            km_aferido: null,
            is_viagem_invalida: 0,
            motivo_viagem_invalida: null,
            data_hora_invalidacao: null,
            data_hora_invalidacao_extenso: null,
            dt_revalidacao: null,
            dt_revalidacao_extenso: null,
            id_usuario_revalidacao: null,
            nome_usuario_revalidacao: null,
        },
        defaultViagem: {
            id_viagem_grid: null,
            id_viagem_prevista: null,
            horario_saida_realizada: null,
            horario_chegada_realizada: null,
            id_viagem_realizada: null,
            id_guia_realizada: null,
            numero_guia_realizada: null,
            id_veiculo_realizado: null,
            numero_ordem_veiculo_realizado: null,
            escalonamento_veiculo: null,
            id_motorista_realizado: null,
            matricula_motorista_realizado: null,
            nome_motorista_realizado: null,
            id_cobrador_realizado: null,
            matricula_cobrador_realizado: null,
            nome_cobrador_realizado: null,
            id_sentido: null,
            id_cerca_inicio: null,
            nome_cerca_inicio: null,
            cod_cerca_inicio: null,
            id_cerca_fim: null,
            nome_cerca_fim: null,
            cod_cerca_fim: null,
            tempo_de_placa: null,
            passageiros_totais: null,
            passageiros_pagantes: null,
            passageiros_gratuidades: null,
            passageiros_vt: null,
            hodometro_inicial: null,
            dt_hodometro_inicial: null,
            hodometro_final: null,
            dt_hodometro_final: null,
            consumo_inicial: null,
            dt_consumo_inicial: null,
            consumo_final: null,
            dt_consumo_final: null,
            id_origem: null,
            temp_media: null,
            condicao_climatica: null,
            id_motivo_abertura_manual: null,
            observacoes_abertura_manual: null,
            id_motivo_fechamento_manual: null,
            observacoes_fechamento_manual: null,
            dt_abertura_manual: null,
            id_usuario_abertura_manual: null,
            dt_fechamento_manual: null,
            id_usuario_fechamento_manual: null,
            dt_associacao_manual: null,
            id_usuario_associacao_manual: null,
            id_linha_associada: null,
            cod_linha_associada: null,
            id_classificacao: null,
            nome_usuario_abertura_manual: null,
            nome_usuario_fechamento_manual: null,
            tipo_abertura: null,
            tipo_fechamento: null,
            dt_abertura_manual_extenso: null,
            dt_fechamento_manual_extenso: null,
            ocupacao: null,
            lotacao: null,
            km_aferido: null,
            is_viagem_invalida: 0,
            motivo_viagem_invalida: null,
            data_hora_invalidacao: null,
            data_hora_invalidacao_extenso: null,
            dt_revalidacao: null,
            dt_revalidacao_extenso: null,
            id_usuario_revalidacao: null,
            nome_usuario_revalidacao: null,
        },
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.initialize();
    },
    computed: {
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('conciliacaoViagens.validation.selectDate')],
            }
        },
        show() {
            return this.dialog;
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
                rules: [this.dtRules]
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
                rules: [this.dtRules]
            }
        },
        dateDiff() {
            let start = typeof this.dti === "string" ?
                new Date(this.dti.substring(6, 10), this.dti.substring(3, 5) - 1, this.dti.substring(0, 2), this.dti.substring(11, 13), this.dti.substring(14, 16), this.dti.substring(17, 19)) :
                this.dti;
            let end = typeof this.dtf === "string" ?
                new Date(this.dtf.substring(6, 10), this.dtf.substring(3, 5) - 1, this.dtf.substring(0, 2), this.dtf.substring(11, 13), this.dtf.substring(14, 16), this.dtf.substring(17, 19)) :
                this.dtf;

            return (end - start) / 3600000;
        },
        guiasFiltered() {
            let g = this.guias;

            if (this.veiculoSelected) {
                g = g.filter((g) => g.id_veiculo == this.veiculoSelected.id_veiculo);
            }

            if (this.idLinhaAssociada) {
                g = g.filter((g) => g.id_linha === this.idLinhaAssociada);
            }

            return g;
        },
        selectedLinha() {
            return this.idLinhaAssociada ? this.linhaAssociadaDetalhe : null;
        },
        veiculoNaoCadastrado() {
            return this.veiculos.findIndex(v => v.id_veiculo == this.veiculoSelected?.id_veiculo) === -1;
        },
    },
    methods: {
        initialize() {
            this.getConfig();
            this.populaMotivos();
            this.populaSentidos();
            this.populaVeiculos();
            this.populaPosicoes();
            this.populaGuias();
            this.populaClassificacoes();
            this.populaCercasSelect();
            this.populaTiposEntrada();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    this.center = [this.config.lat_default, this.config.lng_default];
                    this.currentCenter = this.center;
                },
            });
        },
        populaMotivos() {
            apiController.request(apiController.endpoints.getallMotivos, {
                onSuccess: (response) => {
                    this.motivos = response.data;
                },
            });
        },
        populaTiposEntrada() {
            apiController.request(apiController.endpoints.getallTiposentrada, {
                onSuccess: (response) => {
                    this.tiposEntradaDiario = response.data;
                },
            });
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculos, {
                onSuccess: (response) => {
                    this.veiculos = response.data;
                },
            });
        },
        populaSentidos() {
            apiController.request(apiController.endpoints.getallSentidos, {
                onSuccess: (response) => {
                    this.sentidos = response.data;
                },
            });
        },
        /** Rotulo do item no select lazy: mantem o codigo visivel junto do nome. */
        rotuloLinha(item) {
            if (!item) return '';
            return item.cod_linha ? `${item.nome_linha} (${item.cod_linha})` : item.nome_linha;
        },
        /**
         * Registro completo da linha, buscado por id no getalllinhas paginado.
         * O select e lazy e nao devolve distancia_ida/distancia_volta.
         */
        async carregaDetalheLinha(idLinha) {
            if (idLinha == null || idLinha === '') {
                this.linhaAssociadaDetalhe = null;
                return null;
            }
            if (this.linhaAssociadaDetalhe && this.linhaAssociadaDetalhe.id_linha == idLinha) {
                return this.linhaAssociadaDetalhe;
            }
            // Query montada fora da chamada: um literal aqui viraria allowlist em
            // apiEndpoints (generate:api-endpoints) e descartaria filter_id_linha.
            const consulta = Object.assign(
                { page: 1, rowsPerPage: 1, total: 'true', showInactives: 'true' },
                { filter_id_linha: String(idLinha) }
            );
            try {
                const response = await apiController.request(apiController.endpoints.getallLinhas, {
                    data: consulta,
                    silent: true,
                });
                const items =
                    response && response.data && Array.isArray(response.data.items)
                        ? response.data.items
                        : [];
                this.linhaAssociadaDetalhe = items.length ? items[0] : null;
            } catch (e) {
                this.linhaAssociadaDetalhe = null;
            }
            return this.linhaAssociadaDetalhe;
        },
        onLinhaAssociadaSelect(val) {
            this.idLinhaAssociada = val != null && val !== '' ? val : null;
            this.carregaDetalheLinha(this.idLinhaAssociada);
        },
        /** Semeia o select lazy com a linha ja associada a viagem. */
        syncLinhaSelect() {
            const ref = this.$refs.linhaSelect;
            if (!ref || typeof ref.setData !== 'function') return;
            const id = this.idLinhaAssociada;
            if (id != null && id !== '') {
                ref.cacheSelectedItems([{
                    id_linha: id,
                    cod_linha: this.editedViagem.cod_linha_associada || this.editedViagem.cod_linha,
                    nome_linha: this.editedViagem.nome_linha,
                }], 'id_linha');
                ref.setData(id);
            } else if (typeof ref.resetData === 'function') {
                ref.resetData();
            }
            if (typeof ref.loadLazyItems === 'function') {
                ref.loadLazyItems('');
            }
        },
        populaClassificacoes() {
            apiController.request(apiController.endpoints.getallClassificacoes, {
                onSuccess: (response) => {
                    this.classificacoes = response.data;
                },
            });
        },
        populaGuias() {
            let dtf = DateUtils.getDateSQLFormatted(new Date());
            let dti = new Date();
            dti.setDate(dti.getDate() - 1);
            dti = DateUtils.getDateSQLFormatted(dti);

            apiController.request(apiController.endpoints.getGuiasdata, {
                params: { dti, dtf },
                onSuccess: (response) => {
                    this.guias = response.data;
                },
            });
        },
        populaCercasSelect() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                onSuccess: (response) => {
                    this.cercasSelect = response.data;
                },
            });
        },
        async populaMapa(bypassValidation = false) {
            if (!bypassValidation && this.$refs.form) {
                this.$refs.form.validate();
            }
            if (this.isFormValid || bypassValidation) {
                this.mapaPopulado = true;
                this.populaPosicoes();
                this.populaRotas();
                this.populaCercas();
            }
        },
        async populaPosicoes() {
            this.loadingPosicoes = true;
            const payload = {
                id: this.veiculoSelected?.id_veiculo,
                dti: DateUtils.getDateSQLFormatted(this.dtiPosicoes),
                dtf: DateUtils.getDateSQLFormatted(this.dtfPosicoes)
            }
            const response = await apiController.request(apiController.endpoints.getPosicoesporcarrodata, { data: payload, silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.loadingPosicoes = false;
            this.posicoes = response.data;
            this.horarioSaidaRealizada = this.dtiPosicoes;
            this.horarioChegadaRealizada = this.dtfPosicoes;
            if (this.posicoes.length > 0) {
                this.currentCenter = [this.posicoes[0].lat, this.posicoes[0].lng];
            }
        },
        async populaRotas() {
            const response = await apiController.request(apiController.endpoints.getRotasporlinha, { data: [this.idLinhaAssociada], silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            let rotas = response.data;
            if (rotas.length > 0) {
                this.rotas = rotas.filter((rota) => rota.id_sentido == this.editedViagem.id_sentido).map((rota) => {
                    rota.geojson = JSON.parse(rota.geojson);
                    return rota;
                });
            }
        },
        async populaCercas() {
            const response = await apiController.request(apiController.endpoints.getCercasporlinha, { data: [this.idLinhaAssociada], silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            let cercas = response.data;
            if (cercas.length > 0) {
                this.cercas = cercas.filter((cerca) => cerca.id_sentido == this.editedViagem.id_sentido || cerca.id_sentido == -1).map((cerca) => {
                    let color = cerca.id_tipo_cerca == 2 || cerca.id_tipo_cerca == 3 ? "#43A047" : "#4287f5";
                    cerca.style = {
                        color: color,
                        weight: 1,
                        fillColor: color,
                        fillOpacity: 0.3
                    };
                    cerca.geojson = JSON.parse(cerca.geojson);
                    // Add onEachFeature for non-circular stops to show tooltips
                    if (cerca.is_circular == 0) {
                        cerca.options = {
                            onEachFeature: (feature, layer) => {
                                if (cerca.nome_cerca) {
                                    layer.bindTooltip(cerca.nome_cerca);
                                }
                            }
                        };
                    }
                    return cerca;
                });
                this.cercasCirculares = this.cercas.filter((cerca) => cerca.is_circular == 1);
                this.cercasGeojson = this.cercas.filter((cerca) => cerca.is_circular == 0);
            }
        },
        close() {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            this.limpaCamposViagem();
            this.$emit('close');
        },
        async getHodometro() {
            const payload = {
                idveiculo: this.editedViagem.id_veiculo_realizado,
                dti: this.editedViagem.horario_saida_realizada,
                dtf: this.editedViagem.horario_chegada_realizada
            }
            // Falha (401, 500...) rejeita a promise; quem trata é o catch de updateViagemGrid.
            const response = await apiController.request(apiController.endpoints.getHodometrokmcarro, { data: payload, silent: true });

            return Array.isArray(response.data) ? response.data : [];
        },
        async insertEntradaDiario(idmotivo, observacoes) {
            const payload = {
                id_tipo_entrada_diario: 1,
                id_motivo: idmotivo,
                dt_entrada: DateUtils.getDateSQLFormatted(new Date()),
                id_usuario_inclusao: this.user.id_usuario,
                observacoes: observacoes,
            }

            const response = await apiController.request(apiController.endpoints.insertEntrada, { data: payload, silent: true });

            return response.data.insertId;
        },
        async insertEntradaLinhas(idEntrada, idLinha) {
            const payload = [[idEntrada, idLinha]];

            await apiController.request(apiController.endpoints.insertLinhasentradabulk, { data: payload, silent: true });
        },
        async insertEntradaVeiculos(idEntrada, idVeiculo) {
            const payload = [[idEntrada, idVeiculo]];

            await apiController.request(apiController.endpoints.insertVeiculosentradabulk, { data: payload, silent: true });
        },
        saveEntrada() {
            this.diarioFormValidado = this.$refs.diarioForm.validate();
            if (this.diarioFormValidado) {
                this.itemDiario.dt_entrada = DateUtils.getDateSQLFormatted(this.dtEntradaDiario);
                this.itemDiario.id_usuario_inclusao = this.user.id_usuario;

                apiController.request(apiController.endpoints.insertEntrada, {
                    data: this.itemDiario,
                    onSuccess: (response) => {
                        if (this.editedViagem.id_linha) {
                            let entradasLinhas = [[response.data.insertId, this.editedViagem.id_linha]];
                            this.saveLinhasEntrada(entradasLinhas);
                        }

                        if (this.editedViagem.id_veiculo_realizado) {
                            let entradasVeiculos = [[response.data.insertId, this.editedViagem.id_veiculo_realizado]];
                            this.saveVeiculosEntrada(entradasVeiculos);
                        }

                        if (this.editedViagem.id_viagem_realizada) {
                            let entradasViagens = [[response.data.insertId, this.editedViagem.id_viagem_realizada]];
                            this.saveViagensEntrada(entradasViagens);
                        }

                        const motivo = this.motivos.find((m) => m.id_motivo == this.itemDiario.id_motivo);
                        this.entradasDiario.push({
                            id_entrada_diario: response.data.insertId,
                            id_tipo_entrada_diario: this.itemDiario.id_tipo_entrada_diario,
                            descricao_tipo_entrada: this.tiposEntradaDiario.find((t) => t.id_tipo_entrada_diario == this.itemDiario.id_tipo_entrada_diario).descricao_tipo_entrada,
                            id_motivo: this.itemDiario.id_motivo,
                            descricao_motivo: motivo ? motivo.descricao_motivo : null,
                            dt_entrada: this.formatDateString(this.itemDiario.dt_entrada),
                            observacoes: this.itemDiario.observacoes
                        });
                        this.itemDiario = Object.assign({}, this.defaultItemDiario);
                        this.$refs.diarioForm.resetValidation();
                    },
                }).catch(() => {});
            }
        },
        formatDateString(dateString) {
            let year = dateString.substring(0, 4);
            let month = dateString.substring(4, 6);
            let day = dateString.substring(6, 8);
            let hour = dateString.substring(8, 10);
            let minute = dateString.substring(10, 12);
            let second = dateString.substring(12, 14);

            return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
        },
        saveLinhasEntrada(entradasLinhas) {
            apiController.request(apiController.endpoints.insertLinhasentradabulk, {
                data: entradasLinhas,
            }).catch(() => {});
        },
        saveVeiculosEntrada(entradasVeiculos) {
            apiController.request(apiController.endpoints.insertVeiculosentradabulk, {
                data: entradasVeiculos,
            }).catch(() => {});
        },
        saveViagensEntrada(entradasViagens) {
            apiController.request(apiController.endpoints.insertViagensrealizadasentradabulk, {
                data: entradasViagens,
            }).catch(() => {});
        },
        preencheEntradas(idViagemRealizada) {
            if (this.entradasDiario.length > 0) {
                let entradasVeiculos = this.entradasDiario
                    .filter((e) => !e.id_veiculo)
                    .map((e) => [e.id_entrada_diario, this.editedViagem.id_veiculo_realizado]);

                if (entradasVeiculos.length > 0) {
                    this.saveVeiculosEntrada(entradasVeiculos);
                }

                let entradasLinhas = this.entradasDiario
                    .filter((e) => !e.id_linha)
                    .map((e) => [e.id_entrada_diario, this.editedViagem.id_linha]);

                if (entradasLinhas.length > 0) {
                    this.saveLinhasEntrada(entradasLinhas);
                }

                let entradasViagens = this.entradasDiario
                    .filter((e) => !e.id_viagem_realizada)
                    .map((e) => [e.id_entrada_diario, idViagemRealizada]);

                if (entradasViagens.length > 0) {
                    this.saveViagensEntrada(entradasViagens);
                }
            }
        },
        populaEntradasDiario() {
            this.loadingDiario = true;
            let today = DateUtils.getDateSQLFormatted(new Date());
            let dataInicial = today.substring(0, 8) + "000000";
            let dataFinal = today;

            let body = {
                dti: dataInicial,
                dtf: dataFinal,
                idlinhas: null,
                idveiculos: null
            }

            if (this.editedViagem.id_viagem_realizada) {
                body.idviagensrealizadas = [this.editedViagem.id_viagem_realizada];
            } else {
                body.idviagensprevistas = [this.editedViagem.id_viagem_prevista];
            }

            apiController.request(apiController.endpoints.getEntradaspordata, {
                data: body,
                onSuccess: (response) => {
                    this.entradasDiario = response.data;
                    this.loadingDiario = false;
                },
                onError: () => {
                    this.loadingDiario = false;
                },
            }).catch(() => {});
        },
        atualizarViagem(tipo) {
            if (tipo == 1) {
                this.editedViagem.horario_saida_realizada = this.posicaoSelected ? DateUtils.getDateSQLFormatted(new Date(this.posicaoSelected?.dt_posicao)) : DateUtils.getDateSQLFormatted(this.horarioSaidaRealizada);
                this.editedViagem.horario_saida_realizada_extenso = this.editedViagem.horario_saida_realizada.substring(11, 16);
                this.horarioSaidaRealizada = new Date(this.editedViagem.horario_saida_realizada);
                this.editedViagem.dt_abertura_manual = DateUtils.getDateSQLFormatted(new Date());
                this.editedViagem.dt_abertura_manual_extenso = new Date().toLocaleString();
                this.editedViagem.id_usuario_abertura_manual = this.user.id_usuario;
                this.editedViagem.tipo_abertura = "Manual";
            } else {
                this.editedViagem.horario_chegada_realizada = this.posicaoSelected ? DateUtils.getDateSQLFormatted(new Date(this.posicaoSelected?.dt_posicao)) : DateUtils.getDateSQLFormatted(this.horarioChegadaRealizada);
                this.editedViagem.horario_chegada_realizada_extenso = this.editedViagem.horario_chegada_realizada.substring(11, 16);
                this.horarioChegadaRealizada = new Date(this.editedViagem.horario_chegada_realizada);
                this.editedViagem.dt_fechamento_manual = DateUtils.getDateSQLFormatted(new Date());
                this.editedViagem.dt_fechamento_manual_extenso = new Date().toLocaleString();
                this.editedViagem.id_usuario_fechamento_manual = this.user.id_usuario;
                this.editedViagem.tipo_fechamento = "Manual";
            }

            this.posicaoSelected = null;
            this.atualizadoPelaPosicao = true;
        },
        async revalidarViagem() {
            if (!this.editedViagem.id_viagem_grid) {
                return;
            }

            this.revalidating = true;
            try {
                const response = await apiController.request(apiController.endpoints.revalidarviagemgrid, {
                    data: {
                        id_viagem_grid: this.editedViagem.id_viagem_grid,
                        dtReferencia: this.dtReferencia,
                    },
                    silent: true,
                });

                if (response.status !== 200 || response.data.erro) {
                    EventBus.$emit('show-error', {
                        error: { response: response.data, status: response.status },
                    });
                    return;
                }

                const viagemAtualizada = response.data.viagem
                    ? { ...this.editedViagem, ...response.data.viagem, is_viagem_invalida: 0 }
                    : this.montarViagemRevalidadaLocal();

                this.editedViagem = Object.assign({}, viagemAtualizada);

                EventBus.$emit('show-alert', {
                    mensagem: response.data.mensagem,
                    tipo: 'success',
                });

                this.$emit('revalidated', viagemAtualizada);
            } catch (error) {
                EventBus.$emit('show-error', { error });
            } finally {
                this.revalidating = false;
            }
        },
        montarViagemRevalidadaLocal() {
            const agora = new Date();
            return {
                ...this.editedViagem,
                is_viagem_invalida: 0,
                id_usuario_revalidacao: this.user.id_usuario,
                nome_usuario_revalidacao: this.user.nome_usuario,
                dt_revalidacao: DateUtils.getDateSQLFormatted(agora),
                dt_revalidacao_extenso: agora.toLocaleString('pt-BR'),
            };
        },
        /**
         * As chamadas do salvamento são `silent` e encadeadas com await: sem este catch,
         * um 401/500 em qualquer uma delas (ou um erro de script no meio do caminho)
         * rejeitava a promise e o botão de salvar simplesmente não fazia nada.
         */
        async updateViagemGrid() {
            if (this.salvando) return;
            this.salvando = true;
            try {
                await this.salvaViagemGrid();
            } catch (error) {
                console.error('Erro ao salvar a viagem:', error);
                // Mês fechado já é avisado pelo apiController, mesmo em chamada silent.
                if (!apiController.isErroMesFechado(error)) {
                    EventBus.$emit('show-error', { error });
                }
            } finally {
                this.salvando = false;
            }
        },
        async salvaViagemGrid() {
            this.$refs.formDetalhesViagem.validate();
            if (this.formValidadoDetalhesViagem) {
                if (!this.idLinhaAssociada && this.editedViagem.id_linha == null) {
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('conciliacaoViagens.validation.selectLine'),
                        tipo: 'error'
                    });
                    return;
                }

                // O select de linha e lazy: garante o registro completo (codigo e
                // distancias) antes de copiar esses campos para a viagem.
                await this.carregaDetalheLinha(this.idLinhaAssociada || this.editedViagem.id_linha);
                if (!this.atualizadoPelaPosicao) {
                    this.atualizarViagem(1);
                    this.atualizarViagem(2);
                }

                if (this.editedViagem.id_cerca_inicio && !this.editedViagem.nome_cerca_inicio) {
                    let cercaInicio = this.cercas.find((cerca) => cerca.id_cerca == this.editedViagem.id_cerca_inicio);
                    this.editedViagem.nome_cerca_inicio = cercaInicio?.nome_cerca;
                    this.editedViagem.cod_cerca_inicio = cercaInicio?.cod_cerca;
                }

                if (this.editedViagem.id_cerca_fim && !this.editedViagem.nome_cerca_fim) {
                    let cercaFim = this.cercas.find((cerca) => cerca.id_cerca == this.editedViagem.id_cerca_fim);
                    this.editedViagem.nome_cerca_fim = cercaFim?.nome_cerca;
                    this.editedViagem.cod_cerca_fim = cercaFim?.cod_cerca;
                }

                if (this.idLinhaAssociada != this.editedViagem.id_linha || this.editedViagem.id_linha == null) {
                    const linhaAssociada = this.linhaAssociadaDetalhe;
                    this.editedViagem.id_linha_associada = this.idLinhaAssociada;
                    this.editedViagem.cod_linha_associada = linhaAssociada.cod_linha;
                    this.editedViagem.dt_associacao_manual = DateUtils.getDateSQLFormatted(new Date());
                    this.editedViagem.id_usuario_associacao_manual = this.user.id_usuario;
                    if (this.editedViagem.id_linha == null) {
                        this.editedViagem.id_linha = this.idLinhaAssociada;
                        this.editedViagem.cod_linha = linhaAssociada.cod_linha;
                    }
                }

                if (this.editedViagem.id_veiculo_realizado != this.veiculoSelected?.id_veiculo || this.editedViagem.id_veiculo_realizado == null) {
                    this.editedViagem.id_veiculo_realizado = this.veiculoSelected?.id_veiculo;
                    this.editedViagem.numero_ordem_veiculo_realizado = this.veiculoSelected?.numero_ordem || this.veiculoSelected;
                }

                // Verificar mudanças no motivo de abertura
                if (this.idMotivoAbertura !== this.editedViagem.id_motivo_abertura_manual ||
                    this.observacoesAbertura !== this.editedViagem.observacoes_abertura_manual) {
                    this.editedViagem.id_motivo_abertura_manual = this.idMotivoAbertura;
                    this.editedViagem.observacoes_abertura_manual = this.observacoesAbertura;
                    if (this.idMotivoAbertura) {
                        const idEntrada = await this.insertEntradaDiario(this.idMotivoAbertura, this.observacoesAbertura);
                        await this.insertEntradaLinhas(idEntrada, this.editedViagem.id_linha);
                        if (this.editedViagem.id_veiculo_realizado) {
                            await this.insertEntradaVeiculos(idEntrada, this.editedViagem.id_veiculo_realizado);
                        }
                    }
                }

                // Verificar mudanças no motivo de fechamento
                if (this.idMotivoFechamento !== this.editedViagem.id_motivo_fechamento_manual ||
                    this.observacoesFechamento !== this.editedViagem.observacoes_fechamento_manual) {
                    this.editedViagem.id_motivo_fechamento_manual = this.idMotivoFechamento;
                    this.editedViagem.observacoes_fechamento_manual = this.observacoesFechamento;
                    if (this.idMotivoFechamento) {
                        const idEntrada = await this.insertEntradaDiario(this.idMotivoFechamento, this.observacoesFechamento);
                        await this.insertEntradaLinhas(idEntrada, this.editedViagem.id_linha);
                        if (this.editedViagem.id_veiculo_realizado) {
                            await this.insertEntradaVeiculos(idEntrada, this.editedViagem.id_veiculo_realizado);
                        }
                    }
                }

                let hodometro = await this.getHodometro();

                // Preferência de hodômetro (switch do card): fonte das leituras gravadas; o km
                // final é recalculado no backend com as duas medições.
                const hodometrosViagem = this.$refs.hodometrosViagem;
                let hodometrosMedidos = null;
                if (hodometro.length > 0) {
                    const medicao = medeHodometros(hodometro[0], hodometrosViagem ? hodometrosViagem.prefereVirtual() : false);
                    this.editedViagem.hodometro_inicial = medicao.hodometro_inicial;
                    this.editedViagem.dt_hodometro_inicial = medicao.dt_hodometro_inicial;
                    this.editedViagem.hodometro_final = medicao.hodometro_final;
                    this.editedViagem.dt_hodometro_final = medicao.dt_hodometro_final;
                    this.editedViagem.km_aferido = medicao.km_aferido;
                    hodometrosMedidos = medicao.hodometros_medidos;
                }

                const linha = this.linhaAssociadaDetalhe;
                this.editedViagem.km_nominal =
                    this.editedViagem.id_sentido == 1 ? linha?.distancia_ida : linha?.distancia_volta;

                let payload = {
                    id_viagem_realizada: this.editedViagem.id_viagem_realizada,
                    id_guia: this.editedViagem.id_guia_realizada,
                    id_linha: this.editedViagem.id_linha,
                    cod_linha: this.editedViagem.cod_linha,
                    id_sentido: this.editedViagem.id_sentido,
                    numero_guia: this.editedViagem.numero_guia_realizada,
                    id_veiculo: this.editedViagem.id_veiculo_realizado,
                    numero_ordem: this.editedViagem.numero_ordem_veiculo_realizado,
                    dt_inicio: this.editedViagem.horario_saida_realizada,
                    dt_fim: this.editedViagem.horario_chegada_realizada,
                    escalonamento: this.editedViagem.escalonamento_veiculo,
                    id_motorista: this.editedViagem.id_motorista_realizado,
                    matricula_motorista: this.editedViagem.matricula_motorista_realizado,
                    nome_motorista: this.editedViagem.nome_motorista_realizado,
                    id_cobrador: this.editedViagem.id_cobrador_realizado,
                    matricula_cobrador: this.editedViagem.matricula_cobrador_realizado,
                    nome_cobrador: this.editedViagem.nome_cobrador_realizado,
                    id_status: this.editedViagem.id_status,
                    hodometro_inicio: this.editedViagem.hodometro_inicial,
                    dt_hodometro_inicio: this.editedViagem.dt_hodometro_inicial,
                    hodometro_fim: this.editedViagem.hodometro_final,
                    dt_hodometro_fim: this.editedViagem.dt_hodometro_final,
                    consumo_inicio: this.editedViagem.consumo_inicial,
                    dt_consumo_inicio: this.editedViagem.dt_consumo_inicial,
                    consumo_fim: this.editedViagem.consumo_final,
                    dt_consumo_fim: this.editedViagem.dt_consumo_final,
                    id_origem: this.editedViagem.id_origem,
                    temp_media: this.editedViagem.temp_media,
                    condicao_climatica: this.editedViagem.condicao_climatica,
                    id_usuario_abertura_manual: this.editedViagem.id_usuario_abertura_manual,
                    dt_abertura_manual: this.editedViagem.dt_abertura_manual,
                    id_usuario_fechamento_manual: this.editedViagem.id_usuario_fechamento_manual,
                    dt_fechamento_manual: this.editedViagem.dt_fechamento_manual,
                    id_usuario_associacao_manual: this.editedViagem.id_usuario_associacao_manual,
                    dt_associacao_manual: this.editedViagem.dt_associacao_manual,
                    tempo_de_placa: this.editedViagem.tempo_de_placa,
                    id_cerca_inicio: this.editedViagem.id_cerca_inicio,
                    cod_cerca_inicio: this.editedViagem.cod_cerca_inicio,
                    nome_cerca_inicio: this.editedViagem.nome_cerca_inicio,
                    id_cerca_fim: this.editedViagem.id_cerca_fim,
                    cod_cerca_fim: this.editedViagem.cod_cerca_fim,
                    nome_cerca_fim: this.editedViagem.nome_cerca_fim,
                    passageiros_totais: this.editedViagem.passageiros_totais,
                    passageiros_pagantes: this.editedViagem.passageiros_pagantes,
                    passageiros_gratuidades: this.editedViagem.passageiros_gratuidades,
                    passageiros_vt: this.editedViagem.passageiros_vt,
                    id_motivo_abertura_manual: this.editedViagem.id_motivo_abertura_manual,
                    id_motivo_fechamento_manual: this.editedViagem.id_motivo_fechamento_manual,
                    observacoes_abertura_manual: this.editedViagem.observacoes_abertura_manual,
                    observacoes_fechamento_manual: this.editedViagem.observacoes_fechamento_manual,
                    id_viagem_grid: this.editedViagem.id_viagem_grid,
                    km_aferido: this.editedViagem.km_aferido,
                    km_nominal: this.editedViagem.km_nominal,
                    id_linha_associada: this.editedViagem.id_linha_associada,
                    cod_linha_associada: this.editedViagem.cod_linha_associada,
                    id_classificacao: this.editedViagem.id_classificacao,
                    processar_viagem: true,
                    ocupacao: this.ocupacao,
                    dt_ocupacao_manual: this.editedViagem.ocupacao != this.ocupacao ? DateUtils.getDateSQLFormatted(new Date()) : null,
                    id_usuario_ocupacao_manual: this.editedViagem.ocupacao != this.ocupacao ? this.user.id_usuario : null,
                    lotacao: this.editedViagem.lotacao,
                    flag_sem_posicao: this.posicoes.length === 0,
                    km_aferido_manual: this.editedViagem.km_aferido != this.kmAferido ? this.kmAferido : null,
                    id_usuario_afericao_km_manual: this.editedViagem.km_aferido != this.kmAferido ? this.user.id_usuario : null,
                    dt_afericao_km_manual: this.editedViagem.km_aferido != this.kmAferido ? DateUtils.getDateSQLFormatted(new Date()) : null,
                    hodometros_medidos: hodometrosMedidos,
                    ...(hodometrosViagem ? hodometrosViagem.alteracaoPreferencia() : {})
                };

                let response;

                if (this.editedViagem.id_viagem_grid === null) {
                    const dataInicio = this.editedViagem.horario_saida_realizada

                    const horaInicialConfig = this.config?.hora_inicial_dia_operacao || "03:00";
                    const [horaConfig, minConfig] = horaInicialConfig.split(":").map(Number);

                    const dataInicioComparacao = new Date(dataInicio);
                    dataInicioComparacao.setHours(horaConfig, minConfig, 0, 0);

                    let dtReferenciaDate;
                    if (dataInicio < dataInicioComparacao) {
                        // Subtrai 1 dia
                        dtReferenciaDate = new Date(dataInicio);
                        dtReferenciaDate.setDate(dtReferenciaDate.getDate() - 1);
                    } else {
                        dtReferenciaDate = new Date(dataInicio);
                    }

                    // Formata para yyyymmdd
                    const yyyymmdd = dtReferenciaDate.getFullYear().toString() +
                        String(dtReferenciaDate.getMonth() + 1).padStart(2, '0') +
                        String(dtReferenciaDate.getDate()).padStart(2, '0');

                    payload.dt_referencia = yyyymmdd;

                    response = await apiController.request(apiController.endpoints.insertViagemgrid, { data: payload, silent: true });
                } else {
                    response = await apiController.request(apiController.endpoints.updateViagemgrid, { data: payload, silent: true });
                }

                // Falha de banco volta com status 200 e { erro: true }: sem este teste a
                // mensagem de erro saía como sucesso e o diálogo fechava.
                if (response.data.erro) {
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.mensagem,
                        tipo: 'error'
                    });
                    return;
                }

                EventBus.$emit('show-alert', {
                    mensagem: response.data.mensagem,
                    tipo: 'success'
                });

                this.$emit('updated', this.viagem);
                this.close();
            }
        },
        populaCamposViagem() {
            // Se viagem estiver vazia ou não tiver propriedades, limpa os campos
            if (!this.viagem || Object.keys(this.viagem).length === 0 || 
                (!this.viagem.horario_saida_realizada && !this.viagem.horario_chegada_realizada && 
                 !this.viagem.id_viagem_realizada && !this.viagem.id_viagem_grid)) {
                this.limpaCamposViagem();
                return;
            }
            
            console.log('Populando campos da viagem:', this.viagem);
            
            // Copia a viagem para editedViagem
            this.editedViagem = Object.assign({}, this.viagem);
            
            // Popula campos do formulário
            this.veiculoSelected = this.veiculos.find(v => v.id_veiculo == this.editedViagem.id_veiculo || v.id_veiculo == this.editedViagem.id_veiculo_realizado) || null;
            this.idLinhaAssociada = this.editedViagem.id_linha_associada || this.editedViagem.id_linha || null;
            this.carregaDetalheLinha(this.idLinhaAssociada);
            this.$nextTick(() => this.syncLinhaSelect());
            
            // Converte datas para os datetime pickers
            if (this.editedViagem.horario_saida_realizada) {
                try {
                    this.horarioSaidaRealizada = new Date(this.editedViagem.horario_saida_realizada);
                } catch (e) {
                    console.error('Erro ao converter horario_saida_realizada:', e);
                    this.horarioSaidaRealizada = null;
                }
            } else {
                this.horarioSaidaRealizada = null;
            }
            
            if (this.editedViagem.horario_chegada_realizada) {
                try {
                    this.horarioChegadaRealizada = new Date(this.editedViagem.horario_chegada_realizada);
                } catch (e) {
                    console.error('Erro ao converter horario_chegada_realizada:', e);
                    this.horarioChegadaRealizada = null;
                }
            } else {
                this.horarioChegadaRealizada = null;
            }
            
            // Define datas para busca de posições (usando horários da viagem)
            if (this.editedViagem.horario_saida_realizada) {
                try {
                    this.dtiPosicoes = new Date(this.editedViagem.horario_saida_realizada);
                } catch (e) {
                    console.error('Erro ao converter dtiPosicoes:', e);
                }
            }
            if (this.editedViagem.horario_chegada_realizada) {
                try {
                    this.dtfPosicoes = new Date(this.editedViagem.horario_chegada_realizada);
                } catch (e) {
                    console.error('Erro ao converter dtfPosicoes:', e);
                }
            }
            
            // Popula motivos e observações
            this.idMotivoAbertura = this.editedViagem.id_motivo_abertura_manual || null;
            this.observacoesAbertura = this.editedViagem.observacoes_abertura_manual || null;
            this.idMotivoFechamento = this.editedViagem.id_motivo_fechamento_manual || null;
            this.observacoesFechamento = this.editedViagem.observacoes_fechamento_manual || null;
            this.kmAferido = this.editedViagem.km_aferido || this.editedViagem.km_aferido_manual || null;
            this.ocupacao = this.editedViagem.ocupacao || null;
            this.dtEntradaDiario = new Date();
            this.populaEntradasDiario();
            
            // Se tiver veículo e datas, popula o mapa automaticamente
            this.$nextTick(() => {
                if (this.veiculoSelected && this.dtiPosicoes && this.dtfPosicoes) {
                    this.populaMapa(true);
                }
            });
        },
        limpaCamposViagem() {
            this.editedViagem = Object.assign({}, this.defaultViagem);
            this.veiculoSelected = null;
            this.idLinhaAssociada = null;
            this.linhaAssociadaDetalhe = null;
            if (this.$refs.linhaSelect && typeof this.$refs.linhaSelect.resetData === 'function') {
                this.$refs.linhaSelect.resetData();
            }
            this.horarioSaidaRealizada = null;
            this.horarioChegadaRealizada = null;
            this.dtiPosicoes = null;
            this.dtfPosicoes = null;
            this.idMotivoAbertura = null;
            this.observacoesAbertura = null;
            this.idMotivoFechamento = null;
            this.observacoesFechamento = null;
            this.kmAferido = null;
            this.ocupacao = null;
            this.itemDiario = Object.assign({}, this.defaultItemDiario);
            this.entradasDiario = [];
            this.dtEntradaDiario = null;
            this.posicoes = [];
            this.rotas = [];
            this.cercas = [];
            this.cercasGeojson = [];
            this.cercasCirculares = [];
            this.posicaoSelected = null;
            this.atualizadoPelaPosicao = false;
            this.$refs.dtiPosicoesPicker.clearHandler();
            this.$refs.dtfPosicoesPicker.clearHandler();
            this.$refs.horarioSaidaRealizadaPicker.clearHandler();
            this.$refs.horarioChegadaRealizadaPicker.clearHandler();
            if (this.$refs.formDetalhesViagem) {
                this.$refs.formDetalhesViagem.resetValidation();
            }
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            if (this.$refs.diarioForm) {
                this.$refs.diarioForm.resetValidation();
            } else {
                this.diarioFormValidado = false;
            }
        },
        onMapReady() {
            this.map = this.$refs.map.mapObject;
            this.onMapResize();
        },
        onMapResize() {
            this.$refs.map.mapObject.invalidateSize();
        },
        getIconPosicao(reg) {
            const isSelected = this.posicaoSelected && reg.dt_posicao === this.posicaoSelected.dt_posicao;
            const color = isSelected ? "green" : "#4A4A4A";

            // Cache de ícones para evitar recriação desnecessária
            if (!this._iconCache) {
                this._iconCache = {};
            }

            if (!this._iconCache[color]) {
                this._iconCache[color] = L.divIcon({
                    className: "my-custom-pin",
                    html: `<svg width="20" height="20" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                            <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                            <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>`,
                    iconAnchor: [15, 15]
                });
            }

            return this._iconCache[color];
        },
        showDetalhesPosicoes(k) {
            const posicao = this.posicoes[k];
            // Usar comparação estrita e evitar atribuição desnecessária
            if (this.posicaoSelected?.dt_posicao === posicao.dt_posicao) {
                this.posicaoSelected = null;
            } else {
                this.posicaoSelected = posicao;
            }
        },
        latLng(lat, lng) {
            if (lat != null && lng !== null) {
                if (lat.trim() !== "0") {
                    return L.latLng(lat, lng);
                } else {
                    return L.latLng(this.center[0], this.center[1]);
                }
            } else {
                return L.latLng(this.center[0], this.center[1]);
            }
        },
        guiaChanged() {
            let guia = this.guiasFiltered.find((g) => g.id_guia == this.editedViagem.id_guia_realizada);
            if (guia) {
                this.editedViagem.numero_guia_realizada = guia.guia_original;
                this.editedViagem.id_motorista_realizado = guia.id_motorista;
                this.editedViagem.matricula_motorista_realizado = guia.matricula_motorista;
                this.editedViagem.nome_motorista_realizado = guia.nome_motorista;
                this.editedViagem.id_cobrador_realizado = guia.id_cobrador;
                this.editedViagem.matricula_cobrador_realizado = guia.matricula_cobrador;
                this.editedViagem.nome_cobrador_realizado = guia.nome_cobrador;
                this.editedViagem.escalonamento_veiculo = guia.escalonamento;
            }
        },
    }
}
</script>
